module.exports = __webpack_public_path__ + "static/img/media_slide.58c804dd.jpg";